export interface IAutocallRendement{

}

export interface ICollarKIKO{
    
}

export interface IWeddingCakeOptions{

}

export interface ITunnelAsymetrique{

}

export interface ITermeParticipatifAsymetrique{
    
}

export interface ITermeAsymetrique{
    
}

export interface ITermeAsymetriqueDesactivant{
    
}

export interface ITermeAccumulateurKO {

}

export interface ITARF {

}

export interface IWeddingCakeAccumulateur {
    
}

export interface ISwap{

}

export interface ICap{
    
}

export interface ICollar{

}

export interface ISwapKO{

}

export interface ICapKO{

}

export interface ICollarKO{
    
}

export interface IDIYPlacement{

}

export interface IDIYChange{
    
}

export interface ITermeSec{

}

  
export const investmentSupport = ["Dépôt à Terme", "BMTN", "EMTN"]
export const periodicityCoupons = ["Mensuelle", "Bimestrielle", "Trimestrielle", "Semestrielle",  "Annuelle", "In-fine"]
export const periodicityCouponsDette = ["Mensuelle", "Trimestrielle", "Semestrielle",  "Annuelle"]
export const amortissementDette = ["Linéaire", "Progressif", "In-fine", "Personnalisé"]
export const indiceSousJacentDette = ["EONIA", "EURIBOR 1M", "EURIBOR 3M", "EURIBOR 6M", "EURIBOR 12M", "Inflation Française Hors Tabac", "Moyenne EURIBOR 3M"]
export const frequenceFixings = ["Quotidienne", "Hebdomadaire", "Mensuelle", "Bimestrielle", "Trimestrielle", "Semestrielle",  "Annuelle"]
export const amortissement = ["linéaire", "progressif", "in-fine"]
export const indiceSousJacent = ["EURIBOR", "EONIA", "LIBOR"]
export const typeDeFixing = ["pré-fixé", "post-fixé"]
export const conventionDeCalculInteret = ["Ajusté", "Non ajusté"]
export const conventionDePaiement = ["Following", "Modified Following "]
export const currenciesExchange = [
    "EUR/USD", 
    "EUR/AUD", 
    "EUR/CAD", 
    "EUR/CHF", 
    "EUR/CNH", 
    "EUR/CZK", 
    "EUR/DKK", 
    "EUR/GBP", 
    "EUR/HKD", 
    "EUR/HUF", 
    "EUR/JPY", 
    "EUR/NOK", 
    "EUR/NZD", 
    "EUR/PLN", 
    "EUR/SEK", 
    "EUR/SGD", 
    "EUR/ZAR"
]


// WEBPACK FOOTER //
// ./src/type/cotation-form.ts